import { Typography } from '@mui/material';

import { getFooterSentenceStyle } from './style';

export const HaveANiceDay = () => {
  return (
    <Typography {...getFooterSentenceStyle()}>Have a nice day!</Typography>
  );
};
